// extracted by mini-css-extract-plugin
export default {"root":"VNThj_l7","text":"FeCJBQib","connectionType":"zZXoOExP","button":"LKDDpI03"};